<template>
  <div class="scan-modal-messages">
    <img
      v-if="isScanning"
      src="@/assets/images/track-area-lines.svg"
      class="scan-modal-messages__scanning-lines"
      alt="scanning..."
    />
    <footer>
      <div v-if="isFetchingItem" class="scan-modal-messages__info-box scan-modal-messages__info-box--floating">
        <div class="scan-modal-messages__text">Fetching item data</div>
      </div>
      <div v-if="menuItemAdded" class="scan-modal-messages__info-box">
        <div class="scan-modal-messages__icon">
          <img src="@/assets/images/check-circle.svg" class="" />
        </div>
        <div class="scan-modal-messages__text">
          <strong>Item Added to Cart</strong><br />
          {{ menuItemAdded.displayName }}
        </div>
        <div>
          <app-button
            class="scan-modal-messages__view-cart-button"
            text="View Cart"
            :aria-label="'View Cart'"
            :handler="
              () => {
                $emit('viewCartClick');
              }
            "
            :style="{ 'background-color': null }"
          />
        </div>
        <div class="scan-modal-messages__vertical-separator"></div>
        <button class="close scan-modal-messages__close-btn" @click="$emit('itemAddedCloseClick')"></button>
      </div>

      <div v-if="isLoadingCamera" class="scan-modal-messages__info-box">
        <div class="scan-modal-messages__text">Loading camera...</div>
      </div>

      <div v-if="errorMessage && errorMessage.header" class="scan-modal-messages__info-box">
        <div class="scan-modal-messages__info-box">
          <div class="scan-modal-messages__icon">
            <img src="@/assets/images/exclamation-circle.svg" class="" />
          </div>
          <div>
            <div class="scan-modal-messages__text">
              <b>{{ errorMessage.header }}</b>
            </div>
            <div v-if="errorMessage.body" class="scan-modal-messages__text">
              {{ errorMessage.body }}
            </div>
          </div>
        </div>
        <div>
          <app-button
            class="scan-modal-messages__try-again-button"
            text="Try Again"
            :aria-label="'Try Again'"
            :handler="
              () => {
                $emit('tryAgainClick');
              }
            "
          />
        </div>
      </div>
    </footer>
    <template v-if="dialogMessage">
      <div class="scan-modal-messages__dialog-overlay" @click="$emit('dialogCloseClick')" />
      <div class="scan-modal-messages__dialog">
        <h2 v-if="dialogTitle" class="iw-page-title m-b-30">
          {{ dialogTitle }}
        </h2>
        <div class="scan-modal-messages__text iw-body-text-large text-center">
          {{ dialogMessage }}
        </div>
        <app-button
          :ref="'scan-modal-messages__dialog-button'"
          text="Close"
          :aria-label="'Close'"
          :handler="
            () => {
              $emit('dialogCloseClick');
            }
          "
          class="scan-modal-messages__dialog-button m-t-30"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ScanModalMessages",
  props: {
    isLoadingCamera: {
      type: Boolean,
      default: false
    },
    isScanning: {
      type: Boolean,
      default: false
    },
    isFetchingItem: {
      type: Boolean,
      default: false
    },
    menuItemAdded: {
      type: Object,
      default: null
    },
    errorMessage: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      required: true
    },
    dialogMessage: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.scan-modal-messages {
  position: absolute;
  top: 3.5rem;
  width: 100%;
  height: calc(100% - 3.5rem);

  footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }

  &__scanning-lines {
    position: relative;
    width: 85%;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  &__info-box {
    position: relative;
    background-color: white;
    display: flex;
    width: 100%;
    min-height: 78px;
    align-items: center;

    strong {
      color: #53a116;
      font-weight: bold;
      font-size: 1.2em;
    }

    &--floating {
      width: 85%;
      margin: 0 auto 3rem;
      border-radius: 1.3rem;
      padding: 5px 10px;
    }
  }

  &__icon {
    text-align: right;
    height: 25px;
    width: 25px;
    margin: auto 0px auto 16px;
  }

  &__view-cart-button {
    &.btn {
      background-color: #53a116;
      border-radius: 18px;
      width: 83px;
      height: 24px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      padding: 0;
    }
  }

  &__try-again-button {
    &.btn {
      background-color: #53a116;
      border-radius: 18.5px;
      width: 77px;
      height: 24px;
      line-height: 20px;
      margin-left: auto;
      margin-right: 16px;
      padding-bottom: 3px;
      white-space: nowrap;
    }
  }

  &__close-btn {
    top: 16px;
    background-color: initial;
    border: none;
  }

  &__text {
    margin: 0;
    line-height: 22px;
    text-align: left;
    padding: 0 11px;
  }

  &__dialog {
    position: relative;
    background-color: white;
    display: flex;
    width: calc(100% - 100px - 3rem);
    min-height: 4em;
    align-items: center;
    margin: 0 auto 3rem;
    border-radius: 1.3rem;
    padding: 50px;
    top: 50%;
    margin: auto;
    transform: translate(0, -50%);
    flex-direction: column;
  }

  &__dialog-button {
    width: 150px;
    margin: 30px auto 0 auto;

    @include respond-to-mobile {
      width: 100%;
    }
  }

  &__dialog-overlay {
    position: absolute;
    background-color: #0000008a;
    height: 100vh;
    width: 100vw;
  }
}
</style>
